import React from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import DialogContent from "@material-ui/core/DialogContent";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import MatchesCount from "components/MatchesCount";
import MatchedRacesList from "../MatchedRacesList";

import useStyles from "./styles";

interface IProps {
  races: racehorse360.IRaceCondition[];
  isOpen: boolean;
  onClose: () => void;
}

const MatchedRacesPopover = React.memo((props: IProps) => {
  const { races = [], isOpen, onClose } = props;
  const classes = useStyles();

  return (
    <Dialog className={classes.dialog} open={isOpen} onClose={onClose}>
      <DialogTitle>
        <div className={classes.headerTitle}>
          <MatchesCount
            customStyles={{ marginRight: 8 }}
            matchedHorsesCount={races.length}
          />
          <span className={classes.titleText}>Race Condition Matches</span>
        </div>
        <IconButton color="primary" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <MatchedRacesList races={races} />
      </DialogContent>
    </Dialog>
  );
});

export default MatchedRacesPopover;
